import { PayoutReviewViewModel } from '@/features/payouts/admin/review/PayoutReviewViewModel'
import type {
  AlertErrorHandlerFactory,
  AlertFactory,
  AlertRetryWrapperFactory,
} from '@/features/shell'
import { type GetCurrentUserFn } from '@/features/iam'
import { type StreamDownloader } from '@/features/payouts/stream-downloader'
import { type PayoutReviewStore } from './PayoutReviewStore'
import { type AdminPayoutHistoryStore } from './AdminPayoutHistoryStore'
import { AdminTransactionHistoryViewModel } from '@/features/payouts/admin/transaction-history/AdminTransactionHistoryViewModel'

/**
 * View model for the payouts admin pages.
 */
export class PayoutsAdminViewModel {
  readonly reviewVm

  readonly historyVm

  constructor(
    private readonly _payoutReviewStore: PayoutReviewStore,
    private readonly _adminPayoutHistoryStore: AdminPayoutHistoryStore,
    private readonly _newAlert: AlertFactory,
    private readonly _createAlertErrorHandler: AlertErrorHandlerFactory,
    private readonly _createAlertRetryWrapper: AlertRetryWrapperFactory,
    private readonly _getCurrentUser: GetCurrentUserFn,
    private readonly _downloader: StreamDownloader,
  ) {
    this.reviewVm = new PayoutReviewViewModel(
      this._payoutReviewStore,
      this._newAlert,
      this._createAlertErrorHandler,
      this._createAlertRetryWrapper,
      this._getCurrentUser,
    )

    this.historyVm = new AdminTransactionHistoryViewModel(
      this._adminPayoutHistoryStore,
      this._newAlert,
      this._createAlertErrorHandler,
      this._createAlertRetryWrapper,
      this._getCurrentUser,
      this._downloader,
    )
  }
}
